<template>
  <div class="ec-dashboard">
    <div ref="wrapper"></div>
  </div>
</template>
<script>
  import * as echarts from 'echarts'
  import { throttle } from '@/utils'
  export default {
    components: {},
    props: {
      picChartsTitle: {
        type: String,
        default: '',
      },
      picChartsSeries: {
        type: Array,
        default() {
          return []
        },
      },
    },
    data() {
      return {
        myChart: null,
        option: {
          title: {
            text: this.picChartsTitle,
            x: 'center',
          },
          tooltip: {
            trigger: 'item',
            formatter: '{b} : {c}Hr ({d}%)',
          },
          legend: {
            bottom: 0,
            //data: $scope.picChartsLegend
          },
          color: [
            '#1973B2',
            '#104A72',
            '#229CF2',
            '#23A4FF',
            '#1E8CD8',
            '#d48265',
            '#bda29a',
            '#bda29a',
            '#6e7074',
            '#546570',
            '#c4ccd3',
          ],
          series: [
            {
              name: '',
              type: 'pie',
              minAngle: 2,
              radius: '55%',
              center: ['50%', '50%'],
              data: this.picChartsSeries,
              itemStyle: {
                normal: {
                  shadowBlur: 30,
                  shadowColor: 'rgba(0, 0, 0, 0.2)',
                },
              },
            },
          ],
        },
      }
    },
    watch: {
      picChartsSeries: {
        handler() {
          setTimeout(() => {
            this.drawLine()
          }, 50)
        },
        immediate: true,
        deep: true,
      },
      picChartsTitle: {
        handler() {
          setTimeout(() => {
            this.drawLine()
          }, 50)
        },
        immediate: true,
        deep: true,
      },
    },

    mounted() {
      this.drawLine()
      window.addEventListener('resize', throttle(this.resize, 500))
    },
    unmounted() {
      window.removeEventListener('resize', this.resize)
    },
    methods: {
      drawLine() {
        if (!this.myChart) {
          this.myChart = echarts.init(this.$refs.wrapper)
        }
        let option = { ...this.option }
        option.title.text = this.picChartsTitle
        option.series[0].data = this.picChartsSeries
        this.myChart.setOption(option, true)
      },
      resize() {
        if (!this.$refs.wrapper) return
        echarts.init(this.$refs.wrapper).resize()
        this.drawLine()
      },
    },
  }
</script>
<style lang="less" scoped>
  @import '~@/styles/variables.less';
  .ec-dashboard {
    width: 400px;
    height: 400px;
    margin: 0 auto;
    padding: 10px;

    & > div {
      width: 400px;
      height: 400px;
    }
  }
</style>
